export default function createElement(elementType = 'div', elementAttrs = {}, options = {}) {
    const el = document.createElement(elementType);
    Object.keys(elementAttrs).forEach((name) => {
        el.setAttribute(name, elementAttrs[name]);
    });
    if (typeof options.text === 'string' && options.text.length) {
        el.innerText = options.text;
    }
    if (['string', 'object'].indexOf(typeof options.html) > -1 && options.html.length) {
        el.innerHTML = options.html;
    }
    return el;
}
